import React, { useContext } from "react";

import { TimekeepingContext } from "../../../../context/domain/timekeeping/TimekeepingContext";
import { useUiText } from "../../../../hooks/useUiText";

import { Calendar } from "../../../../components/icons/svg/outline/index";

/**
 * ShiftDateDisplay Component
 * 
 * Displays the current date for timekeeping in a formatted card.
 * This component reads the date from TimekeepingContext and formats it
 * for display using the preferred-language date helper.
 * 
 * The date is displayed in a green card with a calendar icon for visual identification.
 * Format used is: "day month DD, YYYY" (e.g., "Tuesday June 04, 2025")
 * 
 * @returns {JSX.Element} A UI card displaying the formatted current date
 */
const ShiftDateDisplay = () => {
  const { date } = useContext(TimekeepingContext);
  const { formatUiDate } = useUiText();

  // Format date for user display
  const formattedDate = formatUiDate(date, "day month DD, YYYY");

  return (
    <div className="bg-gray-300 p-6 mb-2 rounded-md">
      <div className="flex items-center space-x-2">
        <div className="flex-shrink-0">
          <Calendar className="text-gray-700" />
        </div>
        <span className="font-semibold">{formattedDate}</span>
      </div>
    </div>
  );
};

export default ShiftDateDisplay;
